import TabFirm from './TabSavedRows-redux';

export default TabFirm;
